module.exports = __webpack_public_path__ + "img/19-villas.1a99c1d0.jpg";